import Vue from 'vue'
import moment from 'moment'

Vue.filter('formatDate', function (value, format = 'DD.MM.YYYY') {
  if (value) {
    return moment(String(value), 'YYYY-MM-DD').locale('sk').format(format)
  }
})
Vue.filter('formatDateTime', function (value, format) {
  if (value) {
    return moment(String(value), 'YYYY-MM-DD HH:mm:ss').format(
      format ? format : 'DD.MM.YYYY - HH:mm:ss',
    )
  }
})
Vue.filter('formatYear', function (value) {
  if (value) {
    return moment(String(value), 'YYYY-MM-DD').format('YYYY')
  }
})
Vue.filter('formatTime', function (value, format) {
  if (value) {
    return moment(String(value), 'YYYY-MM-DD HH:mm:ss').format(
      format ? format : 'HH:mm:ss',
    )
  }
})
Vue.filter('formatMonths', function (value) {
  if (value) {
    return moment(String(value), 'YYYY-MM-DD').locale('sk').format('MM - MMM')
  }
})
Vue.filter('formatAgo', function (value) {
  if (value) {
    if (moment().diff(value, 'days') > 6) {
      return moment(String(value), 'YYYY-MM-DD HH:mm:ss').format(
        'DD.MM.YYYY - HH:mm:ss',
      )
    }
    return moment(String(value), 'YYYY-MM-DD HH:mm:ss').locale('sk').fromNow()
  }
})

Vue.filter('formatNumber', function (value, decimals) {
  if (!value) {
    value = 0
  }
  if (!decimals) {
    decimals = 0
  }
  if (decimals == -1) {
    return parseFloat(value).toLocaleString('sk-SK')
  }
  let fixed = parseFloat(value).toFixed(decimals)
  return parseFloat(value).toLocaleString('sk-SK', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })
})

Vue.filter('nl2br', function (text) {
  return String(text).replace(/\n/g, '<br/>')
})

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('initials', function (value) {
  if (!value) return ''
  return value
    .split(' ')
    .map((n) => n[0])
    .join('')
})

Vue.filter('toSnake', function (value) {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036F]/g, '')
    .replace(/\W+/g, ' ')
    .split(/ |\B(?=[A-Z])/)
    .map((word) => word.toLowerCase())
    .join('_')
})

// File size conversion filter
let UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
let STEP = 1024

function format(value, power) {
  return (value / Math.pow(STEP, power)).toFixed(2) + UNITS[power]
}

Vue.filter('fileSize', function (num) {
  /*if (typeof num !== 'number' || isNaN(num)) {
    throw new TypeError('Expected a number');
  }*/

  let exponent
  let unit
  let neg = num < 0
  let units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  if (neg) {
    num = -num
  }

  if (num < 1) {
    return (neg ? '-' : '') + num + ' B'
  }

  exponent = Math.min(
    Math.floor(Math.log(num) / Math.log(1000)),
    units.length - 1,
  )
  num = (num / Math.pow(1000, exponent)).toFixed(2) * 1
  num = num.toString().replace(/\./g, ',')
  unit = units[exponent]

  return (neg ? '-' : '') + num + ' ' + unit
})
